module.exports = __webpack_public_path__ + "static/timetravel_img1jpg-69bc8bf6838c094bf79a3b70fad145c1.png";